import { render, staticRenderFns } from "./kibana.vue?vue&type=template&id=dffe7464&scoped=true"
import script from "./kibana.vue?vue&type=script&lang=js"
export * from "./kibana.vue?vue&type=script&lang=js"
import style0 from "./kibana.vue?vue&type=style&index=0&id=dffe7464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffe7464",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
